import { render, staticRenderFns } from "./details.vue?vue&type=template&id=281d2118&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "./details.vue?vue&type=style&index=0&id=281d2118&scoped=true&lang=less&"
import style1 from "./details.vue?vue&type=style&index=1&lang=less&"
import style2 from "./details.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281d2118",
  null
  
)

export default component.exports